export enum AuditType {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  EXPORT = 'EXPORT',
  DOWNLOAD = 'DOWNLOAD',
  INVITE = 'INVITE',
  INVITE_ACCEPT = 'INVITE_ACCEPT',
}
